import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { getBalanceAndPin } from "../../features/balance-and-pin/balanceAndPinSlice";
import { formattedBalance } from "../../features/balance-and-pin/utils";
import Spinner from "../../components/Spinner";
import {
  MainContainer,
  Navbar,
  ContentContainer,
  LogosSection,
  Footer
} from "./styles";
import logo from "./images/pepcity-logo.svg";
import logos from "./images/logos.svg";
import banner from "./images/banner.svg";
import digiseqLogo from "./images/digiseq-logo.png";

const Pepcity25 = () => {
  const [searchParams] = useSearchParams();
  const serialNumber = searchParams.get("serialNumber");

  const dispatch = useDispatch();
  const { balanceAndPin, isLoading } = useSelector(
    (state) => state.balanceAndPin
  );

  useEffect(() => {
    if (!balanceAndPin && serialNumber) {
      dispatch(
        getBalanceAndPin({
          serial: serialNumber,
          query: "?provider=pannovate"
        })
      );
    }
  }, [balanceAndPin, serialNumber, dispatch]);

  if (isLoading) return <Spinner />;
  return (
    <MainContainer>
      <Navbar>
        <img src={logo} alt="logo" />
        <div className="balance-container">
          <div className="balance-text">BALANCE:</div>
          <div className="balance-value">
            {formattedBalance(
              balanceAndPin?.balanceDetails?.availableBalance,
              balanceAndPin?.balanceDetails?.currency
            )}
          </div>
        </div>
      </Navbar>

      <ContentContainer>
        <h1>WELCOME TO MUNICH!</h1>
        <p>
          Your PepCity pass provides you with travel across Munich on Friday or
          Sunday giving you a chance to explore and sightsee at your own
          leisure. Your match ticket provides you with complimentary public
          transport on Saturday from 06:00 to 12:00 on Sunday - simply show your
          match ticket on the UEFA Ticketing App.
        </p>
        <p>
          To purchase a ticket go to any transport hub and use your PepCity pass
          at the ticket machines as you would a debit card - tap to pay. 
        </p>
        <p>
          When you return home you have the option to link your own personal
          payment card to your PepCity pass and carry on using it for
          contactless payments. You can do this{" "}
          <Link
            target="_blank"
            to={`/curve-account/?serialNumber=${serialNumber}&provider=pannovate`}
          >
            here
          </Link>
          .
        </p>
        <p>
          Please visit the PepCity welcome desk in your hotel or call the
          PepCity hotline on{" "}
          <span className="highlight-text"> +44  7741 682 428</span> if you have
          any queries.
        </p>
      </ContentContainer>
      <img src={banner} alt="banner" className="banner" />
      <LogosSection>
        <img src={logos} alt="logos" />
      </LogosSection>
      <Footer>
        <div className="powered-by">Powered by</div>
        <img src={digiseqLogo} alt="digiseq-logo" />
        <div className="links-text">Privacy Policy</div>
        <div className="links-text">Terms & Conditions</div>
      </Footer>
    </MainContainer>
  );
};

export default Pepcity25;
